import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Observable, Subject, interval } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, Validators } from '@angular/forms';
import { Spinner } from 'src/app/spinner';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { takeUntil } from 'rxjs/operators';

export const urlProduzioneMail = 'https://servizi.fondirigenti.it/middlesw/api/oil/progetto/condividi';
export const urlCollaudoMail = 'https://servizi.coll.fondirigenti.it/middlesw/api/oil/progetto/condividi';
export const urlTestMail = 'https://servizi.coll.fondirigenti.it/middlesw/api/oil/progetto/condividi';
export const urlPreProdMail = 'https://servizi-preprod.coll.fondirigenti.it/middlesw/api/oil/progetto/condividi';

export const emailRegex = '[A-z0-9\\.\\+_-]+@[A-z0-9\\._-]+\\.[A-z]{2,6}$';
export const campoNonValorizzato = 'Campo non valorizzato';
export const campoNonValorizzatoCorrettamente = 'Campo non valorizzato correttamente';
export const fileNonValorizzato = 'Aggiungere un file in formato pdf'
export const fileNonValorizzatoCorrettamente = 'File non valorizzato correttamente';

@Component({
  selector: 'app-oilCp-component',
  templateUrl: './oilCp.component.html',
  styleUrls: ['./oilCp.component.scss']
})
export class oilCp implements OnInit {
  allegato: any = null;
  nomeCognome: string = '';
  email: string = '';
  privacy = true;
  errori = { nomeCognome: '', email: '', file: '' };
  unsubscribe$: Subject<void> = new Subject<void>();

  spinner = Spinner.getInstance();
  private theToast: MatSnackBarRef<SimpleSnackBar> = null;

  constructor(private zone: NgZone, private toast: MatSnackBar, private httpClient: HttpClient) {
  }

  ngOnInit() { }

  stringaNonCompilata(str) {
    return (!str || 0 === str.length);
  }

  protected errorePopUp(msg: string, action: string) {
    this.zone.run(() => { this.popUp('alert-error', action, msg, this.toast); });
  }

  protected successPopUp(msg: string, action: string) {
    this.zone.run(() => { this.popUp('alert-success', action, msg, this.toast); });
  }

  popUp(panelClass: string, action: string, msg: string, toast: MatSnackBar) {
    if (this.theToast) {
      this.theToast.instance.data = {
        message: msg,
        action
      };
    } else {
      this.theToast = toast.open(msg, action, {
        // duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass,
        direction: 'ltr',
        politeness: 'off'
      });
    }
    this.theToast.afterDismissed().subscribe(() => {
      this.theToast = null;
    });
  }

  handleFileInput(file: FileList) {
    this.allegato = file[0];
  }

  eliminaFile() {
    this.allegato = null;
  }

  checkBox() {
    this.privacy = !this.privacy;
  }

  check() {
    let ok = true;
    if (this.stringaNonCompilata(this.nomeCognome)) {
      this.errori.nomeCognome = campoNonValorizzato;
      ok = false;
    } else {
      this.errori.nomeCognome = '';
    }
    if (this.stringaNonCompilata(this.email)) {
      this.errori.email = campoNonValorizzato;
      ok = false;
    } else if (this.email.match(emailRegex) === null) {
      this.errori.email = campoNonValorizzatoCorrettamente;
      ok = false;
    } else {
      this.errori.email = '';
    }
    if (this.allegato !== null) {
      if (this.allegato.type !== 'application/pdf') {
        this.allegato = null;
        ok = false;
        this.errorePopUp('Il file caricato deve essere in formato PDF', 'Chiudi');
      } else if (this.allegato.size >= 20971520) {
        this.allegato = null;
        ok = false;
        this.errorePopUp('l\'Upload del file non può essere superiore a 20MB', 'Chiudi');
      }
    } else {
      ok = false;
      this.errorePopUp('Aggiungere un file in formato pdf', 'Chiudi');
    }
    return ok;
  }

  invia() {
    this.spinner.startSpinner();
    if (this.check()) {
      const actionUrl = environment.production ? urlProduzioneMail :
        (environment.collaudo ? urlCollaudoMail :
          (environment.preprod ? urlPreProdMail :
            urlTestMail));
      const formData = new FormData();
      formData.append('nomeCognome', this.nomeCognome);
      formData.append('email', this.email);
      formData.append('file', this.allegato);

      this.httpClient.post<any>(actionUrl, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.spinner.stopSpinner();
        const res = JSON.stringify(data);
        this.successPopUp('Email inviata correttamente', 'chiudi');
        this.nomeCognome = '';
        this.email = '';
        this.allegato = null;
        //this.Azienda.pendingFile = JSON.parse(res);
      }); // , (error) => {this.gestioneErrore(error.networkError, 'httpclient'); });
    } else {
      this.spinner.stopSpinner();
    }
  }

}